module.exports = __webpack_public_path__ + "img/shipped_packages.2ae9757e.svg";